import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { usePlatform } from '../platform/index.ts';

import { IconSettings } from './icons.tsx';

const initials = (name: string): string => {
  if (name === '') return '—';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? '') : '';
  return (first + last).toUpperCase() || '—';
};

export const Topbar = (): ReactNode => {
  const platform = usePlatform();
  const navigate = useNavigate();
  const user = platform.user();
  const name =
    (
      (user?.first_name ?? '') + (user?.last_name !== undefined ? ` ${user.last_name}` : '')
    ).trim() || 'Cardholder';
  return (
    <div className="topbar fade-in">
      <div className="account-chip">
        <div className="account-avatar" aria-hidden="true">
          {initials(name)}
        </div>
        <div className="account-text">
          <p className="account-eyebrow">Account</p>
          <p className="account-name">{name}</p>
        </div>
      </div>
      <button
        type="button"
        className="icon-btn"
        aria-label="Account"
        onClick={(): void => {
          void navigate({ to: '/account' });
        }}
      >
        <IconSettings />
      </button>
    </div>
  );
};
